let uniqueId = 0;

export default  {
  data() {
    return {
      uniqueId: ++uniqueId,
    };
  },
};
